<template><div><h1>VUX V2.4.0 released</h1>
<h2><a href="/en/components/datetime.html">Datetime</a></h2>
<ul><li>[enhance] use the same popup header style as popup-picker</li>
</ul>
<h2><a href="/en/components/drawer.html">Drawer</a></h2>
<ul><li>[feature] new component</li>
</ul>
<h2><a href="/en/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[enhance] re-render when render-month is changed</li>
</ul>
<h2><a href="/en/components/previewer.html">Previewer</a></h2>
<ul><li>[enhance] Use src as msrc by default</li>
<li>[enhance] No more force setting width and height #1426</li>
</ul>
<h2><a href="/en/components/radio.html">Radio</a></h2>
<ul><li>[feature] Add prop:selected-label-style</li>
</ul>
<h2><a href="/en/components/range.html">Range</a></h2>
<ul><li>[fix] Fix the situation cannot drag to max value #1556</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.4.0 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.4.0-106.vue?23a3f3ac